"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.measureFunctionDuration = measureFunctionDuration;
/**
 * This function allows to decorate an arbitrary function and measure its execution time.
 *
 * @example
 *
 * #### With promise as function to be measured
 *
 * ```js
 * const fnc = async () => fetch('https://dk.oriflame.com')
 *    .then((res) => res.json())
 * const { result, duration } = await measureFunctionDuration(fnc)()
 * ```
 *
 * #### Without promise as function to be measured
 * ```js
 * const fnc = () => {
 *   console.log('Doing something that may take a lot of resources!');
 * }
 * const { result, duration } = await measureFunctionDuration(fnc)()
 * ```
 */
function measureFunctionDuration(
/**
 * Function to be measured, can be sync or async
 */
fn) {
  return async (...args) => {
    const t0 = performance.now();
    const result = await Promise.resolve(fn(...args));
    const t1 = performance.now();
    return {
      result,
      duration: t1 - t0
    };
  };
}
